(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dizane-featured-review"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if(root.dataset.nurlanReady) return;
    root.dataset.nurlanReady='true';
    const video=root.querySelector('[data-nurlan-video]');
    const button=root.querySelector('[data-nurlan-play]');
    if(!video || !button) return;
    button.hidden=false;
    button.addEventListener('click',()=>{video.play().then(()=>{button.hidden=true;video.focus();}).catch(()=>{button.hidden=true;video.focus();});});
    video.addEventListener('playing',()=>{button.hidden=true;});
    video.addEventListener('pause',()=>{button.hidden=false;});
    video.addEventListener('ended',()=>{button.hidden=false;});
  };
  document.querySelectorAll('[data-nurlan-review]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-nurlan-review]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dizane-ritual-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async function(event) {
    const link = event.target.closest('[data-dz-guide-download]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    const status = link.closest('.dz-guide__body').querySelector('.dz-guide__status');
    link.setAttribute('aria-busy', 'true');
    status.textContent = link.dataset.loading;
    try {
      const response = await fetch(link.href, { credentials: 'omit' });
      if (!response.ok) throw new Error('Download failed');
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const download = document.createElement('a');
      download.href = url;
      download.download = 'Guide-des-Rituels-Dizane.pdf';
      document.body.appendChild(download);
      download.click();
      download.remove();
      setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
      status.textContent = '';
    } catch (error) {
      status.textContent = link.dataset.error;
    } finally {
      link.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dizane-social-proof"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if(root.dataset.reviewsReady) return;
    root.dataset.reviewsReady='true';
    const track=root.querySelector('.dzr__track'), cards=[...track.children];
    if(!cards.length) return;
    const nav=root.querySelector('.dzr__navigation'), prev=root.querySelector('[data-review-prev]'), next=root.querySelector('[data-review-next]'), status=root.querySelector('[data-review-position]');
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    const index=()=>cards.reduce((best,card,i)=>Math.abs(card.getBoundingClientRect().left-track.getBoundingClientRect().left)<Math.abs(cards[best].getBoundingClientRect().left-track.getBoundingClientRect().left)?i:best,0);
    function update(){const max=track.scrollWidth-track.clientWidth;nav.hidden=max<3;prev.disabled=track.scrollLeft<=3;next.disabled=track.scrollLeft>=max-3;status.textContent=`${index()+1} / ${cards.length}`;}
    function move(delta){const i=Math.max(0,Math.min(cards.length-1,index()+delta));track.scrollBy({left:cards[i].getBoundingClientRect().left-track.getBoundingClientRect().left-2,behavior:reduced.matches?'instant':'smooth'});}
    prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
    track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}if(e.key==='Home'||e.key==='End'){e.preventDefault();track.scrollTo({left:e.key==='Home'?0:track.scrollWidth,behavior:reduced.matches?'instant':'smooth'});}});
    let timer;track.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(update,120);},{passive:true});
    const observer=new ResizeObserver(update);observer.observe(track);
    document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root)){observer.disconnect();clearTimeout(timer);}},{once:true});update();
  }
  document.querySelectorAll('[data-dizane-reviews]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-dizane-reviews]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
